import { GetCopy } from '../util/GetCopy';
import { ReactComponent as Mobile } from '../../src/img/mobile.svg';
import { ReactComponent as PC } from '../../src/img/pc.svg';
import { ReactComponent as CTV } from '../../src/img/tv.svg';

export const ScreenSize = ({ brandData, ScreenSizes, selected, updateSelected }) => {
  const setActice = (e) => {
    updateSelected(e);
  };
  //change this to use the airtable config
  const hasDesktop = brandData['160x600']?.length || brandData.hasOwnProperty['970x250']?.length || false;
  const hasCtv = brandData['16:9']?.length || false;
  const hasMobile = brandData.hasOwnProperty['300x600']?.length || brandData['300x250']?.length || false;

  return (
    <div>
      <b>
        <GetCopy copy="screen size" />
      </b>
      {/* display */}
      {!brandData['Video'] && (
        <div className="screenIcons">
          {ScreenSizes.map((size) => {
            if (size === 'Mobile' && hasMobile) {
              return (
                <div
                  key={size}
                  onClick={size === selected ? undefined : () => {
                    setActice(size);
                  }}
                  className={size === selected ? 'active' : 'inactive'}
                  style={{ cursor: size === selected ? 'default' : 'pointer' }}
                >
                  <Mobile />
                </div>
              );
            }
            if (size === 'Desktop' && hasDesktop) {
              return (
                <div
                  key={size}
                  onClick={size === selected ? undefined : () => {
                    setActice(size);
                  }}
                  className={size === selected ? 'active' : 'inactive'}
                  style={{ cursor: size === selected ? 'default' : 'pointer' }}
                >
                  <PC />
                </div>
              );
            }
            if (size === 'CTV' && hasCtv) {
              return (
                <div
                  key={size}
                  onClick={size === 'CTV' ? undefined : () => {
                    setActice('CTV');
                  }}
                  className={size === 'CTV' ? 'active' : 'inactive'}
                  style={{ cursor: size === 'CTV' ? 'default' : 'pointer' }}
                >
                  <CTV />
                </div>
              );
            }
          })}
        </div>
      )}
      {/* video */}
      {!!brandData['Video'] && (
        <div className="screenIcons">
          {ScreenSizes.map((size, i) => {
            if (size === 'Mobile') {
              return (
                <div
                  key={size}
                  onClick={size === selected ? undefined : () => {
                    setActice(size);
                  }}
                  className={size === selected ? 'active' : 'inactive'}
                  style={{ cursor: size === selected ? 'default' : 'pointer' }}
                >
                  <Mobile />
                </div>
              );
            }
            if (size === 'Desktop') {
              return (
                <div
                  key={size}
                  className={'unavailable inactive'}
                  style={{ cursor: 'not-allowed' }}
                >
                  <PC />
                </div>
              );
            }
            if (size === 'CTV') {
              return (
                <div
                  key={size}
                  className={'unavailable inactive'}
                  style={{ cursor: 'not-allowed' }}
                >
                  <CTV />
                </div>
              );
            }
            return null;
          })}
        </div>
      )}
    </div>
  );
};
